import { useRef } from "react"
import { useModals } from "context/modals/hooks/useModals"
import { useCheckNews } from "./useCheckNews"
import { useCheckPolicy } from "./useCheckPolicy"
import { useCheckTutorial } from "./useCheckTutorial"
import { useCheckDailyReward } from "./useCheckDailyReward"
import { useCheckStakingCompleted } from "./useCheckStakingCompleted"

export const useCheckActionOnLoad = () => {
  const { openModal } = useModals()

  const checkDailyReward = useCheckDailyReward()
  const checkStakingCompleted = useCheckStakingCompleted()
  const checkNews = useCheckNews()
  const checkPolicy = useCheckPolicy()
  const checkTutorial = useCheckTutorial()

  const isTutorialComplete = useRef<boolean>(false)
  const isNoReadPolicy = useRef<boolean>(false)

  const check = async () => {
    isNoReadPolicy.current = await checkPolicy()

    if (!isNoReadPolicy.current) {
      isTutorialComplete.current = (await checkTutorial()) || false

      if (isTutorialComplete.current) {
        await Promise.all([
          checkDailyReward(),
          checkStakingCompleted(),
          checkNews()
        ])
      } else if (!isNoReadPolicy.current) {
        openModal("onboarding")
      }
    }
  }

  return {
    check,
    isTutorialComplete,
    isNoReadPolicy
  }
}
